import { render } from "./reportKitNamePerf.vue?vue&type=template&id=14d02c67"
import script from "./reportKitNamePerf.vue?vue&type=script&lang=js"
export * from "./reportKitNamePerf.vue?vue&type=script&lang=js"

import "./reportKitNamePerf.vue?vue&type=style&index=0&id=14d02c67&lang=scss"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__